import React, { useState } from "react"
import axios from "axios"
import atob from "atob"
import { Link } from "gatsby"
import { TextInput } from "../../common/form/TextInput"
import { CheckBox } from "../../common/form/CheckBox"
import toBase64String from "@utils/toBase64String"

import * as s from "./OutOfStockForm.module.scss"

export const OutOfStockForm = ({ variant }) => {
  const [emailInput, setEmailInput] = useState("")
  const [emailInputError, setEmailInputError] = useState(false)
  const [checkbox, setCheckbox] = useState(false)
  const [checkboxError, setCheckboxError] = useState(false)
  const [submissionError, setSubmissionError] = useState(false)
  const [submissionSuccess, setSubmissionSuccess] = useState(false)

  const decoded = atob(
    variant.shopifyId.includes("gid://shopify/")
      ? toBase64String(variant.shopifyId)
      : variant.shopifyId,
  )
  const shopifyId = decoded.split("/").pop()

  function handleSubmit(e) {
    e.preventDefault()

    if (!emailInput) setEmailInputError(true)
    if (!checkbox) setCheckboxError(true)
    if (!emailInput || !checkbox) return

    const options = {
      method: "POST",
      url: "/.netlify/functions/out-of-stock-notification",
      data: {
        email: emailInput,
        shopifyId: shopifyId,
      },
    }

    axios
      .request(options)
      .then(function (response) {
        console.log(response.data)
        setSubmissionSuccess(true)
      })
      .catch(function (error) {
        console.log(error)
        setSubmissionError(true)
      })
  }

  return (
    <div className={s.outOfStockForm}>
      {!submissionSuccess ? (
        <>
          <h5>Oh no, we've run out!</h5>
          <p>
            Enter your email below and we’ll get in touch when it’s back in
            stock.
          </p>
          {submissionError && (
            <p className={s.submissionError}>
              Sorry, something went wrong - please try again.
            </p>
          )}
          <form onSubmit={e => handleSubmit(e)}>
            <TextInput
              className={s.EmailInput}
              placeholder="Email address"
              value={emailInput}
              onChange={e => {
                setEmailInput(e.target.value)
                setEmailInputError(false)
              }}
              error={emailInputError}
              requireEmail={true}
            />
            <div className={s.checkBoxContainer}>
              <div className={s.col1}>
                <CheckBox
                  value={checkbox}
                  onChange={e => {
                    setCheckbox(e)
                    setCheckboxError(false)
                  }}
                  error={checkboxError}
                />
              </div>
              <div className={s.col2}>
                <label htmlFor="">
                  Your personal data will be processed in line with our{" "}
                  <Link to="/privacy-policy">Privacy Notice</Link>.
                </label>
              </div>
            </div>
            <button type="submit">
              <span>Submit</span>
            </button>
          </form>
        </>
      ) : (
        <>
          <h5>We'll be in touch!</h5>
          <p>You'll get an email when this is back in stock.</p>
        </>
      )}
    </div>
  )
}
